import { Model, Factory } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'

export type HomeDeliveryOrderData = {
  readonly id: string
}

export const model = Model.extend({}) as ModelDefinition<HomeDeliveryOrderData>

export const factory = Factory.extend<HomeDeliveryOrderData>({
  id(i: number) {
    return String(i + 1)
  },
})
